import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'truncate'})

export class TruncatePipe implements PipeTransform {
	transform(input: number, treshold: number, decimals: number, significantDigits: number): number {
		if (input) {
			if (input < treshold && input > 0) {
				return Number((input).toFixed(decimals));
			} else {
				return Number((input).toPrecision(significantDigits));
			}
		} else {
			return 0;
		}
	}
}
